import Vue from 'vue'

export const userKey = '__hionTecnologia_usuario'
//export const baseApiUrl = 'http://localhost:1146'
//export const baseApiUrl = 'http://192.168.15.37:1146'
//export const thumblerKey = '@/thumbler/'
//export const baseApiUrl = 'http://192.168.99.100:1146'
export const baseApiUrl = 'http://ec2-54-146-182-125.compute-1.amazonaws.com:1146'

export function showError(e) {
    if(e && e.response && e.response.data) {
        Vue.toasted.global.defaultError({ msg : e.response.data })
    } else if(typeof e === 'string') {
        Vue.toasted.global.defaultError({ msg : e })
    } else {
        Vue.toasted.global.defaultError()
    }
}


export default { baseApiUrl, showError, userKey, /*thumblerKey*/ }
